import classNames from 'classnames';
import { LogoType } from '@Components/Base';
import { useDownloadDocumentQuery } from '@Store/api/dmsApiSlice';
import { ReactComponent as LockIcon } from '@Icons/additional/lock.svg';
import { ReactComponent as DownloadIcon } from '@Icons/additional/download.svg';

import styles from './document-tab-item.module.css';

interface MaterialDocumentItemProps {
  name: string;
  type: string;
  status: boolean;
  description: string;
  isConfidential: boolean;
  filePath?: string;
  documentId?: string;
  onDownload?: (url: string | undefined, filePath: string) => void;
}

const MaterialDocumentItem: React.FC<MaterialDocumentItemProps> = ({
  name,
  type,
  status,
  description,
  filePath,
  documentId,
  onDownload,
  isConfidential,
}) => {
  const { data: fileUrl } = useDownloadDocumentQuery(documentId || '', {
    skip: !documentId,
  });

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.wrapper}>
          <div className={styles.documentIcon}>
            <LogoType fileExt={type} />
          </div>
          <div>
            <div className={classNames(styles.caption, styles.documentName)}>
              {name} {isConfidential && <LockIcon />}
            </div>
            <div className={styles.documentType}>{type}</div>
          </div>
        </div>
        <div className={styles.actions}>
          <div
            className={classNames(
              styles.state,
              status ? styles.inactive : styles.active
            )}
          >
            {status ? 'Inactive' : 'Active'}
          </div>
          {onDownload && documentId && filePath && (
            <DownloadIcon
              className={styles.download}
              onClick={() => onDownload(fileUrl, filePath)}
            />
          )}
        </div>
      </div>
      <div className={styles.content}>{description}</div>
    </div>
  );
};

export default MaterialDocumentItem;
